@if (asiakkaanIbanitObservable | async; as asiakkaanIbanit) {
  <div>
    @if (asiakkaanIbanit?.length) {
      <div>
        <div class="title">Asiakkaan valtuuttamat tilinumerot</div>
        @for (iban of asiakkaanIbanit; track iban) {
          <div>{{ iban.iban }} ({{ iban.bic }}, {{ iban.bank }})</div>
        }
        <form>
          <div class="title">Hae tilitapahtumat Enable Banking API:sta</div>
          <div style="width: 430px; padding-top: 5px">
            <mat-form-field>
              <mat-label>IBAN</mat-label>
              <mat-select [formField]="lomake.iban">
                @for (iban of asiakkaanIbanit; track iban) {
                  <mat-option [value]="iban"> {{ iban.iban }} ({{ iban.bic }}, {{ iban.bank }}) </mat-option>
                }
              </mat-select>
              @if (naytaVirhe(lomake.iban, 'required')) {
                <mat-error> IBAN puuttuu </mat-error>
              }
            </mat-form-field>
          </div>
          <mat-form-field style="width: 200px; margin-right: 30px">
            <mat-label>Hae tilitapahtumat alkaen</mat-label>
            <input matInput type="text" [matDatepicker]="fetchStartPicker" [formField]="lomake.start" />
            <mat-datepicker-toggle matSuffix [for]="fetchStartPicker"></mat-datepicker-toggle>
            @if (naytaVirhe(lomake.start, 'required')) {
              <mat-error> Päivämäärä puuttuu </mat-error>
            }
          </mat-form-field>
          <mat-datepicker #fetchStartPicker></mat-datepicker>
          <mat-form-field style="width: 200px">
            <mat-label>Hae tilitapahtumat loppuen</mat-label>
            <input matInput type="text" [matDatepicker]="fetchEndPicker" [formField]="lomake.end" />
            <mat-datepicker-toggle matSuffix [for]="fetchEndPicker"></mat-datepicker-toggle>
            @if (naytaVirhe(lomake.end, 'required')) {
              <mat-error> Päivämäärä puuttuu </mat-error>
            }
            @if (naytaVirhe(lomake.end, 'endBeforeStart')) {
              <mat-error> Loppupäivämäärä on ennen alkua </mat-error>
            }
          </mat-form-field>
          <mat-datepicker #fetchEndPicker></mat-datepicker>
          <div style="margin: 30px 0">
            <app-primary-button (click)="startEnableBankingFetch()" actionId="Synkronoi Enable Banking tapahtumat kirjanpitoon" [actionContext]="[$any(lomake().value())]" styles="margin-right: 15px;"> Synkronoi kirjanpitoon </app-primary-button>
            <app-primary-button (click)="getRawEnableBankingTransactions()" actionId="Hae Enable Banking tapahtumat tarkasteltavaksi" [actionContext]="[$any(lomake().value())]" styles="margin-right: 15px;"> Hae tarkasteltavaksi </app-primary-button>
            <app-secondary-button (click)="getSessionAndAccountDetails()" actionId="Hae session ja tilin tiedot" [actionContext]="[$any(lomake().value())]"> Hae session & tilin tiedot </app-secondary-button>
          </div>
        </form>
        @if (accountAndSessionLoadingSubject | async) {
          <div>
            <div style="margin: 30px; text-align: center">
              Session ja tilin tietoja ladataan... <br />
              <mat-spinner style="display: inline-block"></mat-spinner>
            </div>
          </div>
        } @else {
          @if (session()) {
            <div>
              <mat-accordion>
                <mat-expansion-panel hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>Session tiedot:</mat-panel-title>
                  </mat-expansion-panel-header>
                  <pre>{{ session() | json }}</pre>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          }
          @if (account()) {
            <div>
              <mat-accordion>
                <mat-expansion-panel hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>Tilin tiedot:</mat-panel-title>
                  </mat-expansion-panel-header>
                  <pre>{{ account() | json }}</pre>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          }
          @if (balance()) {
            <div>
              <mat-accordion>
                <mat-expansion-panel hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>Saldon tiedot:</mat-panel-title>
                  </mat-expansion-panel-header>
                  <pre>{{ balance() | json }}</pre>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          }
        }
        @if (rawTransactionsStateSubject | async; as transactionState) {
          <div>
            @if (transactionState.showTable) {
              @if (!transactionState.loading) {
                <div>
                  <table style="margin: 10px 0; width: 100%">
                    @for (transaction of transactionState.transactions; track transaction) {
                      <tr style="border-bottom: 1px solid gray; cursor: pointer" (click)="toggleShowDetails(transaction)">
                        <td>{{ transaction.transaction_amount.amount }}</td>
                        <td>{{ transaction.booking_date }}</td>
                      </tr>
                      @if (transaction.showDetails) {
                        <tr style="cursor: pointer" (click)="toggleShowDetails(transaction)">
                          <td colspan="2">
                            <pre>{{ transaction | json }}</pre>
                          </td>
                        </tr>
                      }
                    }
                  </table>
                </div>
              } @else {
                <div style="margin: 30px; text-align: center">
                  Tilitapahtumia ladataan... <br />
                  <mat-spinner style="display: inline-block"></mat-spinner>
                </div>
              }
            }
          </div>
        }
      </div>
    } @else {
      <div class="red-text" style="margin: 4em">Ei voimassa olevia tilejä.</div>
    }
  </div>
} @else {
  <div style="margin: 30px; text-align: center">
    Tilien metatietoja ladataan... <br />
    <mat-spinner style="display: inline-block"></mat-spinner>
  </div>
}
